import { default as ClassNames } from "classnames";
import { FunctionComponent } from "react";
import { SlideImage } from "yet-another-react-lightbox";
import { selectActiveSite } from "../selectors/sites.js";
import { useAppSelector } from "../store/hooks.js";
import styles from "../stylesheets/components/image-gallery-layout-4.module.css";
import moduleBaseStyles from "../stylesheets/components/module-base.module.css";
import {
  ColorScheme,
  ImageModuleSettings,
  Language,
  TitleAndSubtitleTextAlign,
  TranslatedModule,
} from "../types/index.js";
import {
  getGalleryMediaAspectRatio,
  getPlaceholderImage,
} from "../utils/utils.js";
import ModuleHeadings from "./ModuleHeadings.js";
import ImageModule from "./Modules/ImageModule.js";

interface Props {
  title: string;
  subtitle: string;
  textAlign: TitleAndSubtitleTextAlign;
  scheme: ColorScheme;
  isFirstOnPage: boolean;
  imageModules: TranslatedModule<ImageModuleSettings>[];
  slides: SlideImage[];
  isPreview: boolean;
  languageId: Language;
  pageId: string;
  moduleId: string;
  onClickImage: (index: number) => void;
}

const ImageGalleryLayout4: FunctionComponent<Props> = ({
  title,
  subtitle,
  textAlign,
  isFirstOnPage,
  scheme,
  imageModules,
  slides,
  isPreview,
  languageId,
  pageId,
  moduleId,
  onClickImage,
}) => {
  const site = useAppSelector(selectActiveSite);

  const images = imageModules.length
    ? imageModules
    : new Array(4)
        .fill(true)
        .map((_, index) =>
          getPlaceholderImage({
            siteId: site.id,
            pageId,
            languageId,
            parentId: moduleId,
            index,
          }),
        );

  return (
    <div
      className={ClassNames(
        moduleBaseStyles.Module__Wrapper,
        moduleBaseStyles["Module__Wrapper--default-padding"],
      )}
    >
      <ModuleHeadings
        textAlign={textAlign}
        scheme={scheme}
        isFirstOnPage={isFirstOnPage}
        title={title}
        subtitle={subtitle}
      />

      <div className={styles.ImageGalleryLayout4__Wrapper}>
        {images.map((imageModule, index) => {
          const item = slides[index];
          return (
            <a
              href={isPreview || !item ? undefined : item.src}
              className={styles.ImageGalleryLayout4__Item}
              key={imageModule.id}
              onClick={(e) => {
                e.preventDefault();
                onClickImage(index);
              }}
            >
              <ImageModule
                aspectRatio={getAspectRatio(index)}
                sizes="50vw"
                lazyLoad={true}
                width={1920}
                translatedModule={imageModule}
                isPreview={isPreview}
                isSlider={false}
                pageId={pageId}
                scheme={scheme}
                showOverlay={false}
              />
            </a>
          );
        })}
      </div>
    </div>
  );
};

const getAspectRatio = (index: number): number => {
  return getGalleryMediaAspectRatio(index, "layout-4");
};

export default ImageGalleryLayout4;
